<template>
  <div class="zsktlist-page">
    <Header />
    
    <main class="main-content">
      <section class="course-banner">
        <div class="container">
          <div class="course-info">
            <h1 class="course-title">{{ course.title }}</h1>
            <div class="course-meta">
              <span><i class="fas fa-clock"></i>总时长：{{ course.totalDuration }}</span>
              <span><i class="fas fa-users"></i>{{ course.studentsCount }}人正在学习</span>
            </div>
          </div>
        </div>
      </section>

      <div class="container">
        <div class="course-container">
          <div class="course-content">
            <div class="content-left">
              <div class="course-intro">
                <h2>课程简介</h2>
                <p>{{ course.introduction }}</p>
              </div>

              <div class="chapter-list">
                <div class="chapter-item" v-for="(chapter, index) in course.chapters" :key="index">
                  <div class="chapter-header" @click="toggleChapter(index)">
                    <h3 class="chapter-title">{{ chapter.title }}</h3>
                    <span class="chapter-duration">{{ chapter.duration }}</span>
                  </div>
                  <div class="chapter-content" v-show="chapter.isOpen">
                    <div v-html="chapter.content"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="content-right">
              <div class="start-learning">
                <h2>开始学习</h2>
                <button class="btn-primary">立即开始学习</button>
              </div>

              <div class="study-notes">
                <h2>学习注意事项</h2>
                <div>
                  <p>建议按照章节顺序学习</p>
                  <p>每章都配有练习题</p>
                  <p>及时完成课后作业</p>
                  <p>多动手实践代码</p>
                </div>
              </div>

              <div class="course-overview">
                <h2>学习内容概览</h2>
                <div>
                  <p v-for="(chapter, index) in course.chapters" :key="index">
                    {{ index + 1 }}. {{ chapter.title }}
                  </p>
                </div>
              </div>

              <div class="related-courses">
                <h2>相关课程</h2>
                <div class="course-cards">
                  <router-link :to="{ name: 'ZsktList', params: { id: relatedCourse.id } }" 
                               class="course-card" v-for="relatedCourse in relatedCourses" :key="relatedCourse.id">
                    <img :src="require(`@/assets/images/${relatedCourse.image}`)" :alt="relatedCourse.title">
                    <h3>{{ relatedCourse.title }}</h3>
                    <p>{{ relatedCourse.description }}</p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'ZsktList',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      course: {
        id: 1,
        title: '生产排单与技术优化',
        totalDuration: '129分钟',
        studentsCount: 3256,
        introduction: '本课程专为生产计划和排单管理在企业生产管理中的重要性而设计',
        chapters: [
          {
            title: '1. 生产计划和排单管理在企业生产管理中的重要性',
            duration: '5:02',
            content: `
              <p>生产计划是企业生产活动的指南针。通过对市场需求、企业资源、生产能力等因素进行全面分析，企业能够制定出科学合理的生产计划，明确生产目标、生产数量、生产周期等关键指标，为生产活动的有序进行提供有力保障。一个合理的生产计划能够确保企业按时按量完成生产任务，满足客户需求，从而保持市场竞争优势。</p>
              <p>而排单管理则是生产计划得以有效执行的重要保障。排单管理涉及到订单接收、分析、排单顺序确定、排单计划制定与执行等多个环节。通过对订单进行合理分类、优先级划分，以及根据生产能力、原材料供应等因素制定详细的排单计划，企业能够确保生产活动的高效运转。同时，排单管理还需要对生产进度进行实时跟踪，及时发现并解决问题，确保生产计划的顺利实施。</p>
              <p>因此生产计划和排单管理不仅关系到企业的生产效率、产品质量和成本控制，更直接影响到企业的市场竞争力和长期发展。随着市场竞争的日益激烈，企业需要更加重视生产计划和排单管理的优化与创新，以适应不断变化的市场需求，实现可持续发展</p>
              <p>这是我们公司在用的一套生产计划管理的模板方案，也分享给大家。复制可以直接查看和修改使用：https://s.fanruan.com/jggnm</p>
            `,
            isOpen: false
          },
          {
            title: '2. 如何制定生产计划',
            duration: '20:20',
            content: `
              <p>具体性：目标应当明确指出企业希望实现的具体成果，例如提高生产效率、缩短生产周期、提升产品质量、降低生产成本等。这些具体目标将为生产计划管理提供明确的方向，使全体员工在共同努力的过程中有的放矢。</p>
              <p>可衡量性：为了确保目标的实现程度，企业需要设定一些可衡量的指标，以便于对生产计划管理的成果进行实时监控和评估，包括生产周期时间、产品质量合格率、生产成本等，它们将帮助企业在生产过程中不断调整和优化计划，确保目标的顺利实现</p>
              <p>与公司战略紧密相连：生产计划管理的目标应当与公司的整体战略保持一致。这意味着企业在制定生production计划时，需要充分考虑公司的市场定位、产品策略、竞争优势等因素，以确保生产活动的开展能够有力地支持公司的整体发展战略。</p>
            `,
            isOpen: false
          },
          {
            title: '3. 排单管理的流程和原则',
            duration: '42:48',
            content: `
              <h2>排单管理的流程</h2>
              <p>订单的接收与分析：企业销售部门接收到客户订单后，需对订单进行初步分析，包括订单数量、产品种类、交货期限等关键信息。这些信息将作为排单管理的重要依据。</p>
              <p>排单顺序的确定：排单顺序的确定需要考虑多种因素，如客户优先级、订单紧急程度、产品工艺复杂度等。通过综合考虑这些因素，企业可以制定出合理的排单顺序，确保生产资源的有效利用。</p>
              <p>排单计划的制定：在制定排单计划时，企业需充分考虑生产能力、原材料供应、设备状态等因素。通过合理安排生产计划，企业可以确保生产活动的顺利进行，同时降低生产成本</p>
              <p>排单计划的执行与调整：排单计划制定后，企业需按照计划进行生产。然而，在实际生产过程中，可能会遇到各种突发情况，如设备故障、原材料短缺等。因此，企业需对排单计划进行实时调整，确保生产活动的顺利进行。</p>
              <h2>排单管理的原则</h2>
              <p>客户需求优先：企业应充分考虑客户的需求，确保订单能够按时按质完成。对于紧急订单和重要客户，企业可以给予更高的优先级，以满足客户的需求。</p>
              <p>生产效率最大化：企业需通过合理的排单管理，提高生产效率，降低生产成本。在排单过程中，企业应充分考虑生产设备的利用率、生产人员的技能水平等因素，以实现生产效率的最大化</p>
              <p>生产资源合理利用：企业需根据生产能力和原材料供应情况，合理安排生产任务。在排单过程中，企业应避免生产资源的浪费和闲置，确保生产资源的合理利用。</p>
            `,
            isOpen: false
          },
          {
            title: '4. 困境：企业在执行生产计划和排单管理中遇到的问题',
            duration: '14:00',
            content: `
              <h2>生产进度难追踪</h2>
              <p>在企业生产过程中，由于缺乏有效的实时追踪和监控机制，企业往往无法准确掌握生产工单的进度情况。这使得生产管理变得不透明，管理者难以了解生产线的实时状态，也就无法及时作出调整和决策。生产进度的难追踪就导致生产计划的执行效率低下，甚至可能出现生产延误的情况。企业面临着生产进度无法准确控制的风险，这不仅影响了企业的正常运营，还可能给企业的客户关系和声誉带来负面影响。</p>
              <h2>生产过程不透明</h2>
              <p>生产过程的不透明性是企业在生产过程中遇到的另一个难题。由于生产过程数据的监控难度较高，企业往往难以实时获取生产过程中的关键信息。这使得生产派工管理变得混乱无序，企业难以对生产流程进行有效的控制和管理。同时，由于缺乏准确的生产数据支持，企业难以预测交付周期，导致订单延迟问题频发。这不仅增加了企业的运营风险，也使得企业难以对生产活动进行精细化的管理和优化，影响生产效率。</p>
              <h2>急单，插单问题频发，订单易超期</h2>
              <p>由于市场需求的不确定性以及客户需求的多样性，企业常常需要面对突如其来的急单或插单。这些订单通常需要紧急处理，导致原有的生产计划被打乱，生产部门需要迅速调整生产资源和生产顺序以满足这些紧急需求。而每个工序的进度又都影响下一道工序，加上插单、急单，一来二去，订单超期频发，导致客户流失。这不仅增加了企业的运营成本和风险，给企业的客户关系和市场竞争力带来负面影响</p>
            `,
            isOpen: false
          },
          {
            title: '5. 破局：高效利用工具',
            duration: '17:26',
            content: `
              <p>企业面对上述问题时，单纯依赖传统的管理手段已难以满足现代生产的需求。为了提升生产效率和响应速度，降低运营风险，企业亟需引入技术工具来辅助生产管理。这里可以参考简道云的生产管理系统，一键同步开启你的高效生产管理之路>>>https://s.fanruan.com/jggnm</p>
              <h2>快速排产，自动添加生产计划</h2>
              <p>管理者接到订单后，可以在系统里面新增工单，该张工单会自动进入"未派工"，等待派工。</p>
              <p>管理人员根据人员的调配情况，指派给相关人员，派工信息同步后，平台会自动向被派人员的系统上发出通知信息，提示有一个新的任务需要处理</p>
              <h2>追踪实时进度，及时发现问题</h2>
              <p>借助简道云强大的数据分析能力，每个工单的各工序数据汇总分析，通过可视化看板实时展示查询生产进度。在传统的生产方式中，生产进度的查询往往需要人工统计和汇报，不仅效率低下，而且容易出错。而现在，每个工单的各工序数据都会被自动汇总和分析，并通过可视化看板实时展示出来。这样，管理员只需看一眼看板，就能清晰地了解当前的生产进度情况。</p>
              <p>这种实时进度展示不仅使得生产进度更加透明，更能够帮助管理员及时发现和解决潜在问题。例如，如果发现某个工序的生产进度明显滞后，管理员可以立即采取措施进行干预，以避免影响整个生产线的正常运行。同时，实时进度展示还能够提高生产团队的协同效率，使得各个工序之间的衔接更加紧密、顺畅</p>
              <h2>具有交期预警功能，可及时采取措施干预生产</h2>
              <p>在简道云的生产小工单系统中，交期预警功能为企业的生产管理提供了强有力的保障。该功能能够根据每道工序的生产进度百分比，自动采用不同的颜色进行标识。当某道工序的生产进度滞后时，系统会自动发出预警提示，使得生产管理员能够迅速发现问题并采取措施进行干预。</p>
              <p>这种预警机制极大地降低了生产延期的风险。通过及时发现和解决问题，企业能够确保生产进度按计划进行，从而避免因生产延期而导致的客户投诉和信誉损失。同时，交期预警功能还能够提高生产团队的响应速度和应对能力，使得企业在面对突发情况时能够更加从容应对。</p>
            `,
            isOpen: false
          },
          {
            title: '6. 数据可视化分析，便于管理者分析和决策',
            duration: '14:00',
            content: `
              <p>在传统的生产管理中，数据往往以表格、报告等形式呈现，对于非专业数据分析师来说，解读这些数据并提炼出有价值的信息是一项极具挑战性的任务。而简道云的可视化分析功能，则将这些复杂的数据转化为直观、易于理解的图表和图形，让管理者一目了然地掌握生产情况。</p>
              <p>通过可视化分析，管理者可以迅速洞察生产过程中的各个环节，了解各道工序的生产进度、质量状况以及资源利用情况。不仅如此，系统还可以根据历史数据和当前趋势，预测未来的生产走势，为企业的生产计划制定和调整提供有力依据。</p>
              <p>此外，可视化分析还能够帮助管理者发现生产过程中的潜在问题和风险。通过对比不同时间段、不同工序的数据，管理者可以找出生产中的瓶颈和短板，从而有针对性地进行改进和优化。</p>
            `,
            isOpen: false
          }
        ]
      },
      relatedCourses: [
        {
          id: 2,
          image: 'scglkc.jpg',
          title: '生产管理',
          description: '深入学习生产计划制定方法，掌握先进排程技术，提升生产效率。'
        }
      ]
    }
  },
  methods: {
    toggleChapter(index) {
      this.course.chapters[index].isOpen = !this.course.chapters[index].isOpen;
    }
  },
  mounted() {
    // 获取课程ID并加载相应的课程详情
    const courseId = this.$route.params.id;
    if (courseId) {
      // 这里应该根据ID从API获取课程详情
      console.log('Loading course with ID:', courseId);
      // 在实际项目中，这里会调用API获取课程详情
      // this.fetchCourseDetail(courseId);
    }
    
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #009b7b;
  --secondary-color: #006d56;
  --text-color: #2c3e50;
  --white: #ffffff;
}

/* 知识课堂列表页面样式 */
.zsktlist-page {
  padding-top: 80px; /* 为固定头部留出空间 */
}

.course-banner {
  background: linear-gradient(135deg, #009b7b 0%, #4cd4bc 100%);
  padding: 140px 0 60px;
  color: #fff;
  position: relative;
  overflow: hidden;
  margin-top: 0;
}

.course-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('@/assets/images/背景素材.png') center/cover;
  opacity: 0.1;
  z-index: 1;
}

.course-banner .container {
  position: relative;
  z-index: 2;
}

.course-info {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.course-title {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.course-meta {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 1.1rem;
}

.course-meta span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.course-meta i {
  font-size: 1.2em;
}

/* 主要内容区域布局 */
.course-container {
  padding: 40px 0;
  margin: 0 auto;
}

.course-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
}

/* 左侧内容区域样式 */
.content-left {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 30px;
}

.course-intro {
  margin-bottom: 40px;
}

.course-intro h2 {
  color: var(--primary-color);
  font-size: 1.8rem;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.course-intro h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: var(--primary-color);
}

.course-intro p {
  line-height: 1.8;
  color: #546e7a;
}

/* 章节列表样式 */
.chapter-list {
  margin-top: 30px;
}

.chapter-item {
  border: 1px solid rgba(0, 155, 123, 0.05);
  border-radius: 12px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
  background: #fff;
}

.chapter-item:hover {
  box-shadow: 0 8px 20px rgba(0, 155, 123, 0.15);
  transform: translateY(-2px);
  border-color: rgba(0, 155, 123, 0.1);
}

.chapter-header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.chapter-item:hover .chapter-header {
  background: #e5f4f1;
}

.chapter-title {
  font-weight: 500;
  color: #263238;
  flex: 1;
}

.chapter-duration {
  color: #78909c;
  margin: 0 20px;
}

.chapter-content {
  padding: 20px;
  border-top: 1px solid rgba(0, 155, 123, 0.1);
}

.chapter-content div {
  list-style: none;
  padding: 0;
}

.chapter-content p {
  padding: 10px 0;
  color: #546e7a;
  position: relative;
  padding-left: 20px;
  margin: 0;
  line-height: 1.8;
}

.chapter-content p::before {
  content: '';
  position: absolute;
  left: 0;
  top: 18px;
  width: 6px;
  height: 6px;
  background: var(--primary-color);
  border-radius: 50%;
}

.chapter-content h2 {
  color: var(--primary-color);
  font-size: 1.4rem;
  margin: 20px 0 15px 0;
  padding-left: 0;
}

.chapter-content h2::before {
  display: none;
}

/* 右侧内容样式 */
.content-right {
  position: sticky;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-right > div {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.content-right > div:hover {
  animation: softPulse 2s infinite;
}

.content-right h2 {
  color: var(--primary-color);
  font-size: 1.4rem;
  margin-bottom: 20px;
}

.btn-primary {
  width: 100%;
  padding: 15px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.btn-primary::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-primary:hover::after {
  opacity: 1;
}

.btn-primary:hover {
  background: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.2);
}

.study-notes div,
.course-overview div {
  padding: 0;
}

.study-notes p,
.course-overview p {
  padding: 8px 0;
  color: #546e7a;
  position: relative;
  padding-left: 24px;
  margin: 0;
}

.study-notes p::before,
.course-overview p::before {
  content: '\f00c';
  font-family: 'Font Awesome 6 Free';
  font-weight: 900;
  position: absolute;
  left: 0;
  color: var(--primary-color);
}

.course-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.course-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 155, 123, 0.05);
  box-shadow: 0 4px 12px rgba(0, 155, 123, 0.08);
  text-decoration: none;
  color: inherit;
  display: block;
}

.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 155, 123, 0.15);
  border-color: rgba(0, 155, 123, 0.1);
  text-decoration: none;
  color: inherit;
}

.course-card img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.course-card h3 {
  padding: 12px;
  margin: 0;
  font-size: 1rem;
  color: #263238;
}

.course-card p {
  padding: 0 12px 12px;
  margin: 0;
  color: #78909c;
  font-size: 0.9rem;
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes softPulse {
  0% {
    box-shadow: 0 4px 12px rgba(0, 155, 123, 0.08);
  }
  50% {
    box-shadow: 0 4px 20px rgba(0, 155, 123, 0.15);
  }
  100% {
    box-shadow: 0 4px 12px rgba(0, 155, 123, 0.08);
  }
}

.course-intro, .chapter-item, .content-right > div {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .course-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .content-right {
    position: static;
  }
}

@media (max-width: 768px) {
  .course-banner {
    padding: 120px 0 40px;
  }

  .course-title {
    font-size: 2rem;
  }

  .course-meta {
    flex-direction: column;
    gap: 15px;
  }

  .chapter-header {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .chapter-duration {
    margin: 5px 0;
  }
}

@media (max-width: 480px) {
  .course-container {
    padding: 20px;
  }

  .content-left, .content-right > div {
    padding: 15px;
  }

  .course-cards {
    grid-template-columns: 1fr;
  }
}

/* 辅助类 */
.text-primary {
  color: var(--primary-color);
}

.text-success {
  color: #4caf50;
}

.text-muted {
  color: #78909c;
}

.container {
  max-width: 1450px;
  margin: 0 auto;
  padding: 0 15px;
}
</style>